import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';

export class PropertyModel {
	name?: string;
	value?: string;
}


@Injectable({
  providedIn: 'root'
})
export class ConstantsService {

  constructor(private apiService: ApiService) { }

  getProperties() {
    return this.apiService.createGetServiceCall<PropertyModel[]>
        (
            this.apiService.getBaseUrl() + 'properties',
            ''
        );

  }


}
